import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaBook, FaSyncAlt } from 'react-icons/fa'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { PencilSquare } from 'react-bootstrap-icons'
import EditSubjectModal from './EditSubjectModal'
import Cookies from 'js-cookie'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-typeahead'
import { Typeahead } from 'react-bootstrap-typeahead'

const AddSubject = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [user, setUser] = useState(null)

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])
  const [allCourses, setAllCourses] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    class: '',
  })
  const [allSubjects, setAllSubjects] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((response) => {
        console.log(response.data)
        // setData(response.data.data) // Current view (filtered/unfiltered)
        setAllCourses(response.data.data) // Full master list
        setCourses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [])
  const handleCourseChange = (e) => {
    const courseId = e.target.value
    const updatedFilters = { ...selectedFilters, course: courseId }
    setSelectedFilters(updatedFilters)
    handleSelect(updatedFilters)
  }

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }

  // const fetchFilteredData = (selectedValues) => {
  //   const { course } = selectedValues
  //   let updatedData = allSubjects // <- this should be classes, not courses
  //   console.log('updatedData', updatedData)
  //   if (course) {
  //     updatedData = updatedData.filter(
  //       (item) => item.course_id?.toString() === course.toString(),
  //     )
  //   }

  //   setData(updatedData)
  // }
  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allSubjects

    if (course) {
      updatedData = updatedData.filter(
        (item) => item.course_id?.toString() === course.toString(),
      )
    }

    setData(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllSubjects()
      .then((response) => {
        console.log(response.data.data)
        setData(response.data.data)
        setAllSubjects(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [])
  const [selectedData, setSelectedData] = useState({})

  const handleRefresh = async () => {
    try {
      const response = await ApiEndpoints.getAllSubjects()
      setData(response.data.data)
      setAllSubjects(response.data.data)
      setSelectedFilters({ course: '' })
    } catch (error) {
      toast.error('Failed to refresh data.')
    }
  }
  const [newSubject, setNewSubject] = useState({
    subject_names: [''],
    course_id: '',
  })

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target
  //   console.log(
  //     `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
  //   )
  //   setNewSubject((prev) => ({ ...prev, [name]: value }))
  // }

  const handleInputChange = (e, index = null) => {
    const { name, value } = e.target

    if (name === 'course_id') {
      setNewSubject((prev) => ({ ...prev, course_id: value }))
    } else if (name === 'subject_name') {
      const updatedSubjects = [...newSubject.subject_names]
      updatedSubjects[index] = value
      setNewSubject((prev) => ({ ...prev, subject_names: updatedSubjects }))
    }
  }
  const handleAddSubjectField = () => {
    setNewSubject((prev) => ({
      ...prev,
      subject_names: [...prev.subject_names, ''],
    }))
  }

  const handleRemoveSubjectField = (index) => {
    const updatedSubjects = [...newSubject.subject_names]
    updatedSubjects.splice(index, 1)
    setNewSubject((prev) => ({ ...prev, subject_names: updatedSubjects }))
  }

  const handleSave = async () => {
    try {
      if (!newSubject.course_id) {
        toast.error('Please select a course.')
        return
      }
      const payload = {
        course_id: newSubject.course_id,
        subjects: newSubject.subject_names.filter((name) => name.trim() !== ''),
      }

      if (payload.subjects.length === 0) {
        toast.error('Please enter at least one subject name.')
        return
      }
      console.log('Sending data: ', payload)
      const response = await ApiEndpoints.addSubject(payload)
      setNewSubject('Response: ', response)

      // Reset the form after submission
      setNewSubject({
        subject_names: [''],
        course_id: '',
      })
      setShowModal(false)

      toast.success(response.data.result)
    } catch (error) {
      toast.error(error.response?.data?.result)
    }
  }
  const deleteClass = (classId) => {
    setData(data.filter((classItem) => classItem.classId !== classId))
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Subjects</h2>
          {user?.user_type !== 'teacher' && (
            <Button
              variant="light"
              className="fw-bold"
              onClick={() => setShowModal(true)}
            >
              <FaBook
                size={16}
                className="me-2 fw-bold"
                style={{ verticalAlign: 'middle' }}
              />
              <span style={{ verticalAlign: 'middle' }}>Add New Subject</span>
            </Button>
          )}
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Group className="mb-3 text-start fw-bold">
            <Form.Label>Course</Form.Label>
            {/* <Form.Select
              value={selectedFilters.course}
              onChange={handleCourseChange}
            >
              <option value="">Select Course</option>
              {allCourses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cour) => cour.id === Number(selectedFilters.course),
              )}
            />
          </Form.Group>
        </Col>

        {/* <div className="d-none d-md-flex justify-content-end"> */}
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>

      {/* </div> */}
      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Subjects: {filteredData.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>
      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr className="bg-secondary rounded">
            <Th>Subject Name</Th>
            <Th>Course</Th>
            {user?.user_type !== 'teacher' && <Th>Action</Th>}
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index}>
                <Td>{item.subject_name}</Td>
                <Td>
                  {' '}
                  {courses.find((course) => course.id === item.course_id)
                    ?.name || 'N/A'}
                </Td>
                {user?.user_type !== 'teacher' && (
                  <Td className="text-start">
                    <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedClass(item)
                          setShowEditModal(true)
                        }}
                      >
                        <PencilSquare />
                      </Button>
                    </div>
                  </Td>
                )}
              </Tr>
            ))
          ) : (
            <Tr className="bg-light">
              <Td
                colSpan="9"
                className="text-center p-3 ms-3 fw-semibold text-muted"
              >
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <div className="d-flex justify-content-end align-items-center gap-3 mb-5 mt-4">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {/* {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))} */}
          {[...Array(totalPages)]
            .slice(
              Math.max(0, currentPage - 3),
              Math.min(totalPages, currentPage + 2),
            )
            .map((_, i) => {
              const pageNum = Math.max(1, currentPage - 3) + i
              return (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </Pagination.Item>
              )
            })}

          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Subject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course_id"
              value={newSubject.course_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form>
            {/* Class Name Field */}

            {newSubject.subject_names.map((subject, index) => (
              <div key={index} className="mb-3 d-flex align-items-center">
                <Form.Control
                  type="text"
                  name="subject_name"
                  value={subject}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder={`Subject Name ${index + 1}`}
                  className="p-2 border rounded me-2"
                />
                {newSubject.subject_names.length > 1 && (
                  <Button
                    variant="danger"
                    onClick={() => handleRemoveSubjectField(index)}
                  >
                    &times;
                  </Button>
                )}
              </div>
            ))}
            <Button variant="secondary" onClick={handleAddSubjectField}>
              + Add Another Subject
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="rounded-pill px-4"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="rounded-pill px-4"
            onClick={handleSave}
          >
            Save Subject
          </Button>
        </Modal.Footer>
      </Modal>
      <EditSubjectModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        subject={selectedClass}
      />
    </div>
  )
}

export default AddSubject
